/**
 * Reseller-admin invite tab — eager half (CLA-911).
 *
 * Eagerly registers the file route (params validation only) and defers the
 * component + all atom/RPC/design imports to `invite.lazy.tsx`, so the invite
 * chunk stays out of the always-loaded `main` bundle. The admin gate is
 * inherited from the parent `admin_/resellers/route.tsx` — no second gate here.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/clawinstall/admin_/resellers/$customerId/invite")({});
